import { Alert, Button, Stack, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { useContext } from "react";
import UserContext from "../../../services/Context/UserContext";
import Address from "../../Inputs/Address"
import { LoadingButton } from "@mui/lab";
import API from "../../../services/API";
import useReward from "../utils/useReward";
import RewardCard from "./RewardCard";
import useCart from "../utils/useCart";

export default function RewardForm(){

    const { user } = useContext(UserContext)

    const [status, setStatus] = useState('ready')

    const reward = useReward()

    const [contact, setContact] = useState(user)

    const [message, setMessage] = useState('')

    const { setCart } = useCart();


    const handleSubmit = e => {
        e.preventDefault();

        setStatus('submit')

        const order = {user: contact, products: [reward]}

        API.post('/rewards/order', order)
            .then(r => {
                setMessage(r.data.message)
                setStatus('success')
            })
            .catch(e => {
                setStatus('error')
                setMessage(e.response?.data?.message)
            })
    }


    if(status === 'success'){

        return <Alert severity='success'>{message}</Alert>
    }


    return reward &&
        
        <Stack gap={3} maxWidth={600} margin="auto" component="form" onSubmit={handleSubmit}>             

                <Typography>🎁 Obtenez votre récompense :</Typography>

                <Stack alignItems="center">

                    <RewardCard item={reward} disabled />

                </Stack>

                {reward.variant?.id === 'calot' && <>
                
                    <Typography>Veuillez confirmer vos coordonnées pour obtenir votre récompense :</Typography>

                    <TextField 
                        label="Email"
                        type='email'
                        size='small'
                        value={contact.email}
                        onChange={e => setContact({...contact, email: e.target.value})}
                        required
                    />
                            
                    <Address 
                        value={contact}
                        onChange={data => setContact(data)}
                    />

                </>}

                <Stack direction="row" justifyContent="flex-end" gap={2}>
                    <Button 
                        variant="outlined" 
                        type="button"
                        onClick={() => setCart({ reward: null })}
                    >
                        Annuler
                    </Button>

                    <LoadingButton
                        loading={status === 'submit'}
                        type='submit'
                        variant='contained'
                    >
                        Valider
                    </LoadingButton>
                </Stack>


                {status === 'error' && 
                    <Alert severity='error'>
                        {message || "Une erreur s'est produite."}
                    </Alert>
                }

        </Stack>

}